import Vue from 'vue'

class SSORepository {

  // Admin CRUD

  create(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/sso/identity-providers',
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/sso/identity-providers/${id}`,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  update(id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/sso/identity-providers/${id}`,
        method: 'put',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  delete(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/sso/identity-providers/${id}`,
        method: 'delete',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // Admin listing (JWT)

  list(organizationId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/sso/identity-providers',
        method: 'get',
        data: { organizationId },
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // Public endpoints (no auth)

  initiate(slug, returnUrl) {
    const data = { provider: slug }
    if (returnUrl) {
      data.return_url = returnUrl
    }
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/sso/initiate`,
        method: 'get',
        data,
        _noToken: true,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  callback(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/sso/callback',
        method: 'post',
        data,
        _noToken: true,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  logout(userId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/sso/logout',
        method: 'post',
        data: { userId },
        _noToken: true,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  authenticationAttempts(params) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/sso/authentication-attempts',
        method: 'get',
        data: params,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  managedUser(userId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/sso/managed/user/${userId}`,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  tokenLogin(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/sso/token-login',
        method: 'post',
        data,
        _noToken: true,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  providers(organizationId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/sso/providers/${organizationId}`,
        method: 'get',
        _noToken: true,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default new SSORepository()
